import { useEffect } from 'react';
import { type SessionData } from '../../webrtc/session';
import * as session from '../../features/session/session.slice';
import { useAppSelector, useAppDispatch } from '../useReduxToolkit';
import { getSessionDetails } from '../../features/session/session.selectors';

export type EnhancedSessionResponse = SessionData & {
  startTime: number;
};

type UseSessionReturnType = {
  end: () => Promise<void>;
  reconnect: () => Promise<void>;
  disconnect: () => Promise<void>;
  isConnected: boolean;
  sessionId?: string | undefined;
};

export function useSession(): UseSessionReturnType {
  const dispatch = useAppDispatch();
  const { isConnected, sessionId } = useAppSelector(getSessionDetails);

  const end = async (): Promise<void> => {
    return dispatch(session.end()).unwrap();
  };

  const reconnect = async (): Promise<void> => {
    return dispatch(session.reconnect()).unwrap();
  };

  const disconnect = async (): Promise<void> => {
    return dispatch(session.disconnect()).unwrap();
  };

  useEffect(() => {
    void dispatch(session.initialize());
  }, []);

  return {
    reconnect,
    disconnect,
    end,
    isConnected,
    sessionId,
  };
}
